<template>
  <div class="header_main_logo">
    <a
      @click.prevent="$nuxt.$emit('close-mobile-menu');$router.push('/')"
      class="header_main_logo_href"
      href="/"
    >
      <img src="@/assets/s-images/logo-sushiset-svg.svg" alt="">
    </a>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less">
.header_main_logo {
	display: flex;

	&_href {
		display: flex;
		cursor: pointer;

		img {
			width: 200px;
			height: auto;

			@media screen and (max-width: 992px) {
				width: 180px;
			}
		}
	}
}
</style>
